import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { List } from 'immutable'
import isEqual from 'lodash/isEqual'
import { formatMessage } from 'lib/intl'
import SelectList from 'components/common/SelectList'
import { setMyJobsDataViewerFilter } from 'reducers/profile/reducer'
import ArrayHelper from 'helpers/array'

class FilterTask extends Component {
  onChange = values => {
    const { activeTasks, setMyJobsDataViewerFilter } = this.props
    const jobTasks = ArrayHelper.getArrData(values, [])

    if (!isEqual(jobTasks, activeTasks.toArray())) {
      setMyJobsDataViewerFilter({ jobTasks })
    }
  }

  render() {
    const { activeTasks, taskList } = this.props
    const values = ArrayHelper.getValues(activeTasks, taskList)

    return (
      <SelectList
        multiple
        withCheckBox
        hasAllValueOption
        outMultipleValues={{
          all: [],
          empty: [-1],
        }}
        variant="outlined"
        name="tasks"
        label={formatMessage('tasks')}
        list={taskList}
        value={values}
        onClose={this.onChange}
        map={{
          index: 'id',
          text: 'title',
        }}
      />
    )
  }
}

FilterTask.defaultProps = {
  activeTasks: List([]),
  taskList: List([]),
}

FilterTask.propTypes = {
  activeTasks: PropTypes.instanceOf(List),
  taskList: PropTypes.instanceOf(List),
  setMyJobsDataViewerFilter: PropTypes.func.isRequired,
}

export default connect(
  store => ({
    activeTasks: store.getIn(['profile', 'jobsDataViewerFilters', 'jobTasks']),
    taskList: store.getIn(['myJobsDataViewer', 'filters', 'tasks']),
  }),
  {
    setMyJobsDataViewerFilter,
  },
)(FilterTask)
